import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, startWith } from 'rxjs/operators';
import { isEmpty } from 'lodash';

@Component({
  selector: 'app-icon-list',
  templateUrl: './icon-list.component.html',
  styleUrls: ['./icon-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class IconListComponent implements OnInit {
  locationPath$: Observable<string>; // for cases like <use attr.xlink:href="{{ locationPath | async }}#a"></use>

  constructor(private _router: Router) {}

  ngOnInit() {
    this.locationPath$ = this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      filter((locationPath: string) => !isEmpty(locationPath)),
      startWith('/'),
      shareReplay(1)
    );
  }
}
